import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link, useParams } from "react-router-dom";
import NotFound from "./NotFound";
import suitsData from "../data/suits.json";

export default function SuitPage() {
  const { suit } = useParams();
  const suitData = suitsData[suit];

  if (!suitData) {
    return <NotFound />;
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{suitData.title} | ERI</title>
        </Helmet>
      </HelmetProvider>
      <div id={suitData.id} className="content">
        <div className="content-wrapper">
          <div className="content-title">
            <div className="title">
              <img className="title-icon" alt={suitData.title} src={`${process.env.PUBLIC_URL}/img/suit/suit-normal-${suitData.id}.png`}/>
              <h1>{suitData.title}</h1>
              <img className="title-icon" alt={suitData.title} src={`${process.env.PUBLIC_URL}/img/suit/suit-normal-${suitData.id}.png`}/>
            </div>
          </div>
          <div className="content-main">
          <img className="img-desc" alt={suitData.title} src={`${process.env.PUBLIC_URL}/img/suit/suit-desc-${suitData.id}.jpg`}/>
            <div className="content-text">
              <div className="text">
                {suitData.desc.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </div>
              <Link className="btn btn-primary" to="/test-palos">Hacer el test</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
